import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ContactStoredData, Country, LoggedUserService, SimpleReponseResult } from 'ngx-paf-common';
import { Supplier } from 'ngx-paf-common';
import { PS_Search_Suppliers_Result } from 'ngx-paf-common';
import { SuppliersService } from 'ngx-paf-common';
import { SearchSuppliersParameters } from 'ngx-paf-common';
import { SharedDataService } from 'ngx-paf-common';
import { SupplierStatut } from 'ngx-paf-common';
import {  Router } from '@angular/router';
import { ExcelExportData } from "@progress/kendo-angular-excel-export";
import { process, State } from '@progress/kendo-data-query';


import {
  DataStateChangeEvent,
  GridComponent,
  GridDataResult,
  CellClickEvent,
  FilterService
} from "@progress/kendo-angular-grid";


import moment from 'moment';
import { Department } from 'ngx-paf-common';
import { forkJoin, Observable, Subscription } from 'rxjs';

@Component({
  selector: 'search-suppliers',
  templateUrl: './search-suppliers.component.html',
  styleUrls: ['./search-suppliers.component.scss']
})
export class SearchSuppliersListComponent implements OnInit, OnDestroy {

  userDatas: ContactStoredData[] = [];

  @ViewChild('grid') kendoGrid: GridComponent;

  get excelExportFileName(): string {
    let curDate: string = moment().format('DD-MM-YYYY HH-mm');
    return 'Liste fournisseurs ' + curDate + '.xlsx';
  }

  constructor(
    private suppliersService: SuppliersService,
    private router: Router,
    public sharedDataSvc: SharedDataService,
    private loggedUserSvc: LoggedUserService) {
    this.allData = this.allData.bind(this);
  }

  public filters: SearchSuppliersParameters = new SearchSuppliersParameters();
  public visibleFilters: boolean = true;

  public get country(): Country {
    return this.sharedDataSvc.countries.find(c => c.Id == this.filters.CountryId);
  }



  get lstStatuts(): SupplierStatut[] {
    return this.sharedDataSvc.supplierStatuts || [];
  };

  public suppliers: PS_Search_Suppliers_Result[];
  public gridData: GridDataResult;
  public state: State = {
    skip: 0,
    take: 100
  };


  subscriptions: Subscription[] = [];

  ngOnInit(): void {
    if (this.sharedDataSvc.allListsLoaded){
      this._initWhenRefLoaded();
    } else {
      this.subscriptions.push(this.sharedDataSvc.allListsLoadedChange.subscribe(()=>this._initWhenRefLoaded()));
    }
  }

  /***
   * Fonction appelée une fois le référentiel chargé pour s'assurer que tous les objets nécessaires soient disponibles
   */
  private _initWhenRefLoaded(){
    if (this.sharedDataSvc.loggedIntUser != null) {
      setTimeout(() => {
        this.reloadVariableLists((): void => { this.reloadVariableListsComplete() });
      }, 300);
    }
    this.subscriptions.push(this.sharedDataSvc.loggedIntUserChange
      .subscribe(res => {
        this.reloadVariableLists((): void => { this.reloadVariableListsComplete() });
      })
    );
    this.subscriptions.push(this.sharedDataSvc.loggedProfilChange.subscribe(res => {
      this.search();
    })
    );
    this.subscriptions.push(this.suppliersService.onSupplierDeleted.subscribe(res => this.search()));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => {
      if (sub != null && !sub.closed) sub.unsubscribe();
    });
  }


  reloadVariableListsComplete(): void {
    this.search((): void => {
      this.visibleFilters = true;
    });
  }


  reloadVariableLists(loadCompleteCallBack: () => any = null): void {
    this.userDatas = [];
    this.loggedUserSvc.LoggedUserStoredDatas()
    .subscribe(results => {
        this.userDatas = results;
        this.loadFilters();
        if (loadCompleteCallBack) {
          loadCompleteCallBack();
        }
      });
  }

  loadFilters(): void {
    if (this.userDatas.some(ud => ud.Key == 'SEARCH-SUPPLIERS-FILTERS')) {
      this.filters = JSON.parse(this.userDatas.find(ud => ud.Key == 'SEARCH-SUPPLIERS-FILTERS').Datas);
    } else {
      this.reinit();
    }
    if (this.userDatas.some(ud => ud.Key == 'SEARCH-SUPPLIERS-GRIDSTATE')) {
      this.state = JSON.parse(this.userDatas.find(ud => ud.Key == 'SEARCH-SUPPLIERS-GRIDSTATE').Datas);
    }
  }

  storeFilters(): Observable<[SimpleReponseResult, SimpleReponseResult]> {
    return forkJoin([
      this.loggedUserSvc.StoreDatas('SEARCH-SUPPLIERS-FILTERS', this.filters),
      this.loggedUserSvc.StoreDatas('SEARCH-SUPPLIERS-GRIDSTATE', this.state)
    ]);
  }

  toggleDisplayFilters(): void {
    this.visibleFilters = !this.visibleFilters;
  }



  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridData = process(this.suppliers, this.state);
  }

  public reinit() {
    this.suppliers = [];
    this.state = {
      skip: 0,
      take: 100
    };
    this.gridData = process(this.suppliers, this.state);
    this.filters = new SearchSuppliersParameters();
    this.storeFilters().subscribe();
  }

  private _isSearching = false;
  public search(searchComplete: () => any = null): void {
    if (this._isSearching) return;
    this._isSearching = true;
    this.sharedDataSvc.WindowLock(this.sharedDataSvc.lngCod == "EN" ? "Loading suppliers list" : "Chargement de la liste des fournisseurs");
    this.storeFilters()
      .subscribe({
        next:(res: any) => {
          this.suppliersService.getSuppliers(this.filters)
            .subscribe({
                next:(res: PS_Search_Suppliers_Result[]) => {
                  this.suppliers = res;
                  this.suppliers.forEach(item => {
                    (<any>item).isHQ = ((item.HQSiret || '') == '');
                    (<any>item).uniqueIdValue = this.getUniqueNum(item);
                  });
                  if ((this.state.skip || 0) > res.length) {
                    this.state = {
                      skip: 0,
                      take: 100
                    };
                  }
                  this.gridData = process(this.suppliers, this.state);
                  this.sharedDataSvc.WindowUnlock();
                  this._isSearching = false;
                },
              error: (errGetsupplier: any) => {
                  this.sharedDataSvc.WindowUnlock();
                  if (errGetsupplier.status != 401) this.sharedDataSvc.alert(errGetsupplier.Message || errGetsupplier);
                }, 
                complete:(): void => searchComplete && searchComplete()
            });
          },
        error: (errStoreFilters: any) => this.sharedDataSvc.alert(errStoreFilters.Message || errStoreFilters),
        complete:()  =>  this._isSearching = false 
      });
  }

  isSiegeDisplay(item: PS_Search_Suppliers_Result): Observable<string> {
    //return this.pafLabels.getLabelSync((item.HQSiret||'')=='' ? 'Oui': 'Non');
    return this.sharedDataSvc.getLabel((item.HQSiret || '') == '' ? 'Oui' : 'Non');
  }
  public supplierAddress(item: Supplier) {
    return item.SupplierAgencies.find(a => a.IsSupplierAgency == 1)?.Agency?.Address;
  }

  getUniqueNum(item: PS_Search_Suppliers_Result): string {
    let key = Object.keys(item).find(k => k.toLowerCase() == item.FunctionalId.toLowerCase());
    return key ? (<any>item)[key] : "";
  }


  public editSupplier(event: CellClickEvent): void {
    if (event.columnIndex < 6) {//bmloquer l'édition sur le bouton kill
      this.router.navigate([`supplier-details/${event.dataItem.Id}`]);
    }
  }

  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: process(this.excelDatas, {
        sort: [{ field: "SupplierName", dir: "asc" }],
      }).data
    };
    return result;
  }


  get excelDatas(): any[] {
    if (!this.suppliers) return [];
    return this.suppliers.map((item: PS_Search_Suppliers_Result) => {
      if (item) {
        return {
          Id: item.Id,
          SupplierName: item.SupplierName,
          UniqueNum: this.getUniqueNum(item), //  this.labels.getPafLabel(item.FunctionalId) + ':' + this.getUniqueNum(item),
          NumTiers: item.NumTiers,
          City: item.City,
          HQSiret: (item.HQSiret || '') == '' ? this.sharedDataSvc.getLoadedLabel('Oui') : this.sharedDataSvc.getLoadedLabel('Non'),
          LblStatutCod: this.sharedDataSvc.getLoadedLabel(item.LblStatutCod),
          DateStatut: item.DateStatut,
          SuspMotif: item.SuspMotif,
          ReferentInterne: item.InternalContactFirstname + ' ' + item.InternalContactLastname
        }
      } else {
        return null;
      }
    });
  }

  exportToExcel(grid: GridComponent) {
    grid.saveAsExcel();
  }

  get showDepartments(): boolean {
    return this.country == null || this.country.Id == 0 || ['FR', 'GF', 'RE'].indexOf(this.country.CountryCod2) >= 0;
  }


  public gridFiltersChange(values: any[], filterService: FilterService, column: any): void {
    filterService.filter({
      filters: values.map((value) => ({
        field: column.field,
        operator: "eq",
        value,
      })),
      logic: "or",
    });
    this.kendoGrid.autoFitColumns();
  }


  checkNgClass(fieldValue: boolean): any {
    return {
      'far': true,
      'fa-check-square': (fieldValue),
      'fa-square': (!fieldValue),
    };
  }

  get columnKillAllowed(): boolean {
    return this.sharedDataSvc.checkProfilAccessPafSettings('DELETE_SUPPLIER');
  }

}
